import React from 'react'
import { IMkStepperContext, TMkStep } from '@typescript'

import { IWishlistResort } from '@contexts/WishlistContext'
import { Waitlist, WaitlistItem, WaitlistResort, WaitlistItemDetails } from '@account/services/vacwaitlist'
import { type IOwner, type IPastTripsYearGroup, type IUpcomingTrip, type IUpcomingTripsPagination, IMkAnyAccountField, IMkAccountState } from '@account/types'
import { PointsBenefitsData } from '../../hooks/usePointsBenefits'
import { OwnershipData } from '../../hooks/useOwnership'

export interface RefreshTripsOptions {
  forceRefresh?: boolean
  pageNum?: number
  pageSize?: number
}

export interface MkAccountContextType extends IMkStepperContext {
  rciDepositsDraft: {
    steps: TMkStep[]
  }
  selectDepositFields: IMkAnyAccountField[]
  initRCIDepositsFlow: () => () => Promise<void>
  initialState: () => IMkAccountState
  setRCIDepositsError: ({ raw, message }: { raw?: Error; message?: string }) => void
  clearRCIDepositsDraft: () => void
  upcomingTrips: IUpcomingTrip[]
  upcomingTripsPagination: IUpcomingTripsPagination | null
  accountWarnings: string[]
  pastTrips: IPastTripsYearGroup[]
  waitlistData: Waitlist
  waitlistResorts: WaitlistResort[]
  upcomingLoading: boolean
  pastLoading: boolean
  waitlistLoading: boolean
  waitlistResortsLoading: boolean
  refreshTrips: (opts?: RefreshTripsOptions) => Promise<void>
  refreshWaitlistRequests: () => Promise<void>
  refreshWaitlistResorts: (forceRefresh?: boolean) => Promise<void>
  addWaitlistRequest: (newRequest: WaitlistItem) => void
  removeWaitlistRequest: (waitlistId: string) => void
  updateWaitlistRequest: (waitlistId: string, updates: Partial<WaitlistItem>) => void
  rollbackWaitlistChanges: () => void
  fetchWaitlistItemDetails: (waitlistId: string) => Promise<WaitlistItemDetails | null>
  wishlistItems: IWishlistResort[]
  wishlistLoading: boolean
  refreshWishlist: (forceRefresh?: boolean) => Promise<void>
  addToWishlist: (productId: string) => Promise<boolean>
  removeFromWishlist: (productId: string) => Promise<boolean>
  isInWishlist: (productId: string) => boolean
  // Points Benefits
  pointsBenefitsData: PointsBenefitsData | null
  pointsBenefitsLoading: boolean
  pointsBenefitsError: string | null
  refreshPointsBenefits: () => Promise<void>
  resetPointsBenefits: () => void
  getYearSpecificAvailablePoints: (selectedYear: number | string) => string
  getCurrentYearAvailablePoints: () => string
  // Ownership
  ownershipData: OwnershipData | null
  ownershipLoading: boolean
  ownershipError: string | null
  refreshOwnership: () => void
  resetOwnership: () => void
  // Profile
  profileData: IOwner | null
  profileLoading: boolean
  profileError: string | null
  refreshProfile: () => Promise<IOwner | null>
  resetProfile: () => void
}

export const MkAccountContext = React.createContext<MkAccountContextType | undefined>(undefined)
